import { SET_DISPLAY_FIELDS, CLEAR_DISPLAY_FIELDS } from '#action/types';

const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_DISPLAY_FIELDS:
      return [...action.payload];
    case CLEAR_DISPLAY_FIELDS:
      return defaultState;
    default:
      return state;
  }
};
